import * as React from 'react';
import { isElementInViewport } from '../utils/isElementInViewport';
export var useScrollDetector = function (spyRef, additionalOffset) {
    var _a = React.useState(true), isInViewport = _a[0], setIsInViewport = _a[1];
    var scrollToElement = React.useCallback(function () {
        var _a;
        var elementCoords = (_a = spyRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (elementCoords) {
            window.scrollTo({
                top: elementCoords.y + window.scrollY - (additionalOffset !== null && additionalOffset !== void 0 ? additionalOffset : 0),
                behavior: 'smooth',
            });
        }
    }, [additionalOffset, spyRef]);
    var checkIfInViewport = React.useCallback(function () {
        if (spyRef.current) {
            setIsInViewport(isElementInViewport(spyRef.current));
        }
    }, [spyRef]);
    React.useEffect(function () {
        window.addEventListener('scroll', checkIfInViewport);
        return function () { return window.removeEventListener('scroll', checkIfInViewport); };
    }, [checkIfInViewport]);
    return {
        needScroll: !isInViewport,
        scrollToElement: scrollToElement,
    };
};
